import React from "react";

function LiveMatchCard({ match, liveScore, odds }) {
    const formatTime = (startTime) => {
        if (!startTime) return "--:--";
        const date = new Date(startTime);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    if (!match) return null;

    const innings1 = liveScore?.matchInningList?.[0] || null;
    const innings2 = liveScore?.matchInningList?.[1] || null;
    const inningsLabel = innings2 ? "2nd Innings" : "1st Innings";

    return (
        <div className="rcard">
            <div style={{ height: "3px", background: "linear-gradient(90deg,var(--pink),rgba(243,73,255,0.1))" }}></div>
            <div className="rcard-body">
                <div className="rcard-top">
                    <span className="fmt-tag">Virtual IPL · #{match.matchId}</span>
                    <span className="rbadge rb-live">● LIVE</span>
                </div>
                <div className="teams-line">
                    <div className="tblk">
                        <div className="tblk-logo">
                            {match.team1PicURL ? (
                                <img src={match.team1PicURL} alt={match.team1Name}
                                     style={{ width: "32px", height: "32px", objectFit: "contain" }}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : <div className="tblk-emblem">🏏</div>}
                            <div>
                                <div className="tblk-name">{match.team1Name || "TBD"}</div>
                                <div className="tblk-score lv">
                                    {innings1 ? `${innings1.runs}/${innings1.wickets}` : "—"}
                                </div>
                                <div className="tblk-ov">
                                    {innings1 ? `${innings1.numberOfOvers} ov` : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cvs">VS</div>
                    <div className="tblk r">
                        <div className="tblk-logo" style={{ flexDirection: "row-reverse" }}>
                            {match.team2PicURL ? (
                                <img src={match.team2PicURL} alt={match.team2Name}
                                     style={{ width: "32px", height: "32px", objectFit: "contain" }}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : <div className="tblk-emblem">🏏</div>}
                            <div>
                                <div className="tblk-name">{match.team2Name || "TBD"}</div>
                                <div className="tblk-score lo">
                                    {innings2 ? `${innings2.runs}/${innings2.wickets}` : "—"}
                                </div>
                                <div className="tblk-ov">
                                    {innings2 ? `${innings2.numberOfOvers} ov` : "yet to bat"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="odds-mini-row">
                    <div className="om-cell">
                        <div className="om-label">{match.team1Name} win</div>
                        <div className="om-val">{odds ? odds.teamOneOdd.toFixed(2) : "—"}</div>
                    </div>
                    <div className="om-cell">
                        <div className="om-label">Draw</div>
                        <div className="om-val n">15.00</div>
                    </div>
                    <div className="om-cell">
                        <div className="om-label">{match.team2Name} win</div>
                        <div className="om-val">{odds ? odds.teamTwoOdd.toFixed(2) : "—"}</div>
                    </div>
                </div>
                <div className="rcard-foot">
                    <span className="rf-result" style={{ color: "var(--pink)" }}>🔴 In Progress · {inningsLabel}</span>
                    <span className="rf-date">Today {formatTime(match.matchStartTime)}</span>
                </div>
            </div>
        </div>
    );
}

export default LiveMatchCard;
